var vercelBuildOutputConfigBase = {
  version: 3,
  // Note: cleanUrls is NOT supported in the Build Output API config.json
  // Users must add "cleanUrls": true to their vercel.json at project root
  // https://vercel.com/docs/build-output-api/v3/configuration#routes
  routes: []
};
export {
  vercelBuildOutputConfigBase
};
//# sourceMappingURL=vc-build-output-config-base.js.map
